import React from "react";

function Contact() {
  return (
    <div className="page">
      <h1 className="page-title">Contact Us</h1>

      <div className="contact-card">
        <p>
          <strong>College Name:</strong><br />
          Blue Moon Degree College
        </p>

        <p>
          <strong>Affiliation:</strong><br />
          Affiliated to S.K. University<br />
          College Code: 0193
        </p>

        <p>
          <strong>Address:</strong><br />
          Near Gangamma Mori, N.H.205,<br />
          Kutagulla – 515 541,<br />
          Kadiri, Sri Satya Sai District,<br />
          Andhra Pradesh, India
        </p>

        <p>
          <strong>Phone:</strong><br />
          📞 9491703509, 7901628736, 9849789456, 9492039384
        </p>

        <p>
          <strong>Email:</strong><br />
          📧 <a href="mailto:bluemoondegreecollege@gmail.com">
            bluemoondegreecollege@gmail.com
          </a>
        </p>



        <h2>Office Hours</h2>
        <p>
          Monday – Saturday: <strong>9:00 AM – 5:00 PM</strong><br />
          Sunday: <strong>Closed</strong>
        </p>
      </div>
    </div>
  );
}

export default Contact;
